import { render, staticRenderFns } from "./SocialComments.vue?vue&type=template&id=6fd4911a"
import script from "./SocialComments.vue?vue&type=script&lang=js"
export * from "./SocialComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports